import { render } from "./SupplierInvoices.vue?vue&type=template&id=579faa02&scoped=true"
import script from "./SupplierInvoices.vue?vue&type=script&lang=js"
export * from "./SupplierInvoices.vue?vue&type=script&lang=js"

import "./SupplierInvoices.vue?vue&type=style&index=0&id=579faa02&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-579faa02"]])

export default __exports__